export const getTradeInText = (data, country, language) => {
  if (country.toLowerCase() === "ca" && language === "fr") {
    return data.TRADE_IN;
  }
  return "TRADE_IN";
};

export const getResaleText = (data, country, language) => {
  if (country.toLowerCase() === "ca" && language === "fr") {
    return data.RESALE;
  }
  return "RESALE";
};
